import { Params } from "@angular/router";

export class RouteUtils {
    public static resolveRoute(routeConfigPath: string, params?: Params, queryParams?: Params) {
        const url = routeConfigPath.replace(/:(\w+)/g, (match, namedParam) => {
            if (!params || !params[namedParam]) {
                // This will obviously look wrong, but will trigger the intended route at least so we don't
                // get spurious error messages
                return match;
            } else {
                return params[namedParam];
            }
        });

        return url + RouteUtils.queryParamsToString(queryParams);
    }

    private static queryParamsToString(queryParams?: Params) {
        let queryParamsSegment = "";
        let searchMarker = "?";
        if (queryParams) {
            for (const [key, value] of Object.entries(queryParams!)) {
                if (value !== undefined && value !== null) { // not adding to query param if value is not defined
                    queryParamsSegment += searchMarker + key + "=" + encodeURIComponent(value);
                    searchMarker = "&";
                }
            }
        }

        return queryParamsSegment;
    }
}
